import { render, staticRenderFns } from "./DashboardNumbers.vue?vue&type=template&id=0f48e5d2&"
import script from "./DashboardNumbers.vue?vue&type=script&lang=js&"
export * from "./DashboardNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports